<template>
    <div class="config-visibility-one">
        <div class="config-visibility-card rounder-8 mb-4">
            <div class="product-info-header">
                <span class="product-sku-badge">{{ propHead.row.sku }}</span>
                <span class="product-name-text">{{ propHead.row.long_name }}</span>
            </div>
            <div class="row g-3 mb-4">
                <div class="col-6">
                    <label class="form-label fw-600 size-13 text-secondary mb-2">VISIBILIDAD</label>
                    <div class="input-group">
                        <select 
                            class="form-control fw-500 size-16" 
                            v-model="visibility"
                        >
                            <option value="" disabled>Seleccione una opción</option>
                            <option v-for="option in visibilityOptions" :key="option" :value="option">{{ option }}</option>
                        </select>
                    </div>
                    <small class="text-secondary size-12 mt-2 d-block">Define la clasificación de visibilidad para este producto</small>
                </div>
                <div class="col-6">
                    <label class="form-label fw-600 size-13 text-secondary mb-2">VISIBILIDAD (N)</label>
                    <div class="input-group">
                        <input 
                            type="number" 
                            class="form-control fw-500 size-16" 
                            v-model="visibility_number"
                            placeholder="Ingrese el valor numérico"
                            step="0.01"
                        />
                    </div>
                    <small class="text-secondary size-12 mt-2 d-block">Valor numérico de visibilidad</small>
                </div>
            </div>
        </div>

        <div class="config-visibility-current p-3 bg-white rounder-8 border mb-4" v-if="propHead.row">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <span class="size-13 text-secondary">Visibilidad actual del producto</span>
                    <h4 class="fw-600 size-20 mb-0 mt-1 text-secondary">
                        {{ propHead.row.visibility || 'Sin configurar' }}
                    </h4>
                </div>
                <div class="text-end">
                    <span class="size-13 text-secondary">Visibilidad (N) actual</span>
                    <h4 class="fw-600 size-20 mb-0 mt-1 text-secondary">
                        {{ propHead.row.visibility_number || 'Sin configurar' }}
                    </h4>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-success fw-400 px-4" @click="saveVisibility" :disabled="saving || !isFormValid">
                <span v-if="saving">Guardando...</span>
                <span v-else>Guardar</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex';
export default {
    name: 'config-visibility-one',
    props: {
        propHead: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            visibility: '',
            visibility_number: null,
            saving: false,
            visibilityOptions: [
                'A0', 'A1', 'A2', 'A3', 'A4', 'A5',
                'B1', 'B2', 'B3', 'B4', 'B5',
                'C1', 'C2', 'C3', 'C4', 'C5',
                'D1', 'D2', 'D3', 'D4', 'D5',
                'E1','X1','X2','X3','X4'
            ],
        };
    },
    computed: {
        ...mapGetters([
            "authentication_user",
        ]),
        isFormValid() {
            return this.visibility !== '' && 
                   this.visibility_number !== null && 
                   this.visibility_number !== undefined && 
                   this.visibility_number !== '';
        },
    },
    created() {
        this.loadCurrentValues();
    },
    methods: {
        ...mapActions(['update']),
        loadCurrentValues() {
            const row = this.propHead.row;
            if (row) {
                this.visibility = row.visibility || '';
                this.visibility_number = row.visibility_number !== null && row.visibility_number !== undefined ? row.visibility_number : null;
            }
        },
        saveVisibility() {
            if (!this.isFormValid) {
                this.$notification.error('Todos los campos son obligatorios.', { timer: 5, showCloseIcn: true });
                return;
            }
            this.saving = true;
            const data = {
                id: this.propHead.row.id,
                visibility: this.visibility,
                visibility_number: this.visibility_number,
            };
            this.update({
                url: `/api/products/config_visibility/update/`,
                params: data,
            }).then(() => {
                this.saving = false;
                this.$emit('refrest');
                this.$notification.success('Visibilidad actualizada correctamente.', { timer: 5, showCloseIcn: true });
            }).catch((error) => {
                this.saving = false;
                if (error.status == 400) {
                    this.$notification.error(error.data.message || 'Error al guardar la visibilidad.', { timer: 5, showCloseIcn: true });
                } else {
                    this.$notification.error('Error al guardar la visibilidad.', { timer: 5, showCloseIcn: true });
                }
            });
        },
    }
};
</script>

<style scoped>
.config-visibility-card {
    background: #ffffff;
}

.product-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    margin-bottom: 16px;
}

.product-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.product-name-text {
    font-size: 0.9rem;
    font-weight: 500;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.form-control:focus {
    border-color: #1AA179;
    box-shadow: 0 0 0 0.2rem rgba(26, 161, 121, 0.25);
}

.btn-success {
    background-color: #1AA179 !important;
    border-color: #1AA179 !important;
}

.btn-success:hover:not(:disabled) {
    background-color: #158a65 !important;
    border-color: #158a65 !important;
}

.btn-success:disabled {
    opacity: 0.65;
}
</style>
